import { render, staticRenderFns } from "./ResultsHome.vue?vue&type=template&id=7438138d&scoped=true&"
import script from "./ResultsHome.vue?vue&type=script&lang=js&"
export * from "./ResultsHome.vue?vue&type=script&lang=js&"
import style0 from "./ResultsHome.vue?vue&type=style&index=0&id=7438138d&scoped=true&lang=css&"
import style1 from "./ResultsHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7438138d",
  null
  
)

export default component.exports